<template>
  <div class="content profile-content">
    <ProfileNavbar :title="$t('sidebar.notifications')"></ProfileNavbar>
    <router-link
        to="/notification"
        type="button"
        class="btn btn-light btn-back mb-3"
    >
      <img width="6" class="mr-3" src="/images/vector-back-grey.png"/>
      {{ $t('school.back-btn') }}
    </router-link>
    <Loader v-if="loader"/>
    <div class="col-12" v-else>
      <div class="d-flex flex-wrap justify-content-between align-items-center mb-5">
        <h1 class="notification-title">
          <img src="/images/message-check.svg" alt=""/>
          {{ data.title }}
        </h1>
        <p class="notification-date">
          {{ data.date }}
        </p>
      </div>
      <div class="col-12 notification-card">
        <img
            src="/images/1000-BALA-logo.png"
            alt=""
            class="notification-logo"
        />
        <h2 class="notification-fullname">
          {{ data.fullname }}
        </h2>
        <!-- <div class="row notification-results">
          <div class="col-4 notification-results__side order-mobile">
            {{ $t('profile.notifications.detail-logic') }} <span>{{ data.logic }} / {{ data.logic_max }}</span>
          </div>
          <div class="col-12 col-sm-4 notification-results__overall">
            {{ $t('profile.notifications.detail-final') }}
            <span>{{ data.total }} </span>
          </div>
          <div class="col-4 notification-results__side">
            {{ $t('profile.notifications.detail-thinking') }} <span>{{ data.thinking }} / {{ data.thinking_max }}</span>
          </div>
        </div> -->
        <div class="notification-message" v-html="data.message"></div>
        <!-- <div class="notification-callcenter my-3">
          {{ $t('call_centre') }}
          <div class="d-flex align-items-center my-3">
            <a href="tel:87172472910">8 717 247 29 10</a>
            <span>{{ $t('call_paid') }}</span>
          </div>
        </div> -->
        <div class="notification-download-wrapper" v-if="data.data">
          <a target="_blank" class="notification-download"
             :href="API_ROOT+'/storage/'+data.data.certificate.kz">{{ $t('downloadCerificate') }} KZ</a>
          <a target="_blank" class="notification-download"
             :href="API_ROOT+'/storage/'+data.data.certificate.ru">{{ $t('downloadCerificate') }} RU</a>
          <a v-if="data.data.diploma && data.data.diploma[$i18n.locale]" target="_blank" class="notification-download"
             :href="API_ROOT+'/storage/'+data.data.diploma[$i18n.locale]">{{ $t('downloadDiplom') }}</a>
        </div>
        <p class="notification-copyright">
          © 2020 Корпоративный фонд «EL ÜMITI». Все права защищены
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import ProfileNavbar from '@/components/ProfileNavbar'
import Loader from '@/components/Loader'

export default {
  name: 'Settings',
  components: {
    ProfileNavbar,
    Loader
  },
  data() {
    return {
      API_ROOT: window.API_ROOT,
      data: {
        date: '',
        fullname: '',
        is_viewed: 0,
        locale: 'ru',
        logic: '',
        message: '',
        thinking: '',
        title: '',
        total: '',
        type: null
      },
      loader: true
    }
  },
  methods: {
    async getNotificationInfo(id) {
      try {
        const res = await this.$http.get(
            `${window.API_ROOT}/api/user/notifications/${id}`
        )
        if (res.body.data) {
          const notif = res.body.data
          const notifData = notif.data || {}
          this.data = {
            ...notif,
            fullname: notifData.fullname || notif.fullname || '',
            logic: Number(notifData.logic_result || 0).toFixed(2),
            logic_max: Number(notifData.logic_result_max || 0).toFixed(2),
            thinking: Number(notifData.thinking_result || 0).toFixed(2),
            thinking_max: Number(notifData.thinking_result_max || 0).toFixed(2),
            total: Number(notifData.result || 0).toFixed(2),
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loader = false
      }
    }
  },
  mounted() {
    this.getNotificationInfo(this.$route.params.id)
  }
}
</script>

<style lang="scss" scoped>
.notification {
  &-title {
    font-size: 24px;
    color: #05458c;
    font-weight: bold;

    img {
      display: inline-block;
      width: 33px;
      height: 33px;
      margin-right: 10px;
      object-fit: contain;
    }
  }

  &-download-wrapper {
    justify-content: center;
    display: flex;
  }

  &-download {
    min-width: 200px;
    margin: 1rem;
    cursor: pointer;
    text-align: center;
    background-color: #2A8BF2;
    height: 48px;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 48px !important;
    text-decoration: none;
    color: white !important;
    border-radius: 10px;
    min-height: 48px;
    display: block;
    max-width: max-content;
  }

  &-date {
    font-size: 18px;
    color: #05458c;
  }

  &-card {
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #dfe0eb;
    padding: 33px 26px;
  }

  &-logo {
    display: block;
    width: 147px;
    margin: 0 auto;
  }

  &-fullname {
    font-size: 30px;
    color: #05458C;
    text-align: center;
    margin: 32px 0;
    font-weight: bold;
  }

  &-results {
    color: #18A0FB;

    &__side {
      font-size: 14px;
      display: flex;
      flex-direction: column;
      align-items: center;

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }

    &__overall {
      font-size: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;

      span {
        font-size: 30px;
        font-weight: bold;
      }
    }
  }

  &-callcenter {
    display: flex;
    flex-direction: column;
    align-items: center;

    a {
      display: flex;
      align-items: center;
      padding: 11px;
      border-radius: 10px;
      border: 1px solid #DFE0EB;
      margin-right: 10px;

      &::before {
        content: '';
        display: block;
        float: left;
        width: 22px;
        height: 31px;
        margin-right: 10px;
        background-image: url('/images/phone.svg');
        background-position: center;
        background-size: 90%;
        background-repeat: no-repeat;
      }
    }

    span {
      color: #05458C;
      opacity: 0.3;
    }
  }

  &-copyright {
    text-align: center;
    font-size: 14px;
    color: #05458C;
    opacity: 0.3;
  }
}

@media screen and (max-width: 700px) {
  .notification-results__overall {
    margin: 1rem 0;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-mobile {
    order: 1;
  }
  .notification {
    &-title {
      font-size: 16px;

      img {
        display: none;
      }
    }

    &-date {
      font-size: 12px;
      margin-left: auto;
    }

    &-card {
      padding: 33px 13px;
    }

    &-results {
      &__side {
        margin: 1rem 0;
        flex: 0 0 100%;
        max-width: 100%;
        font-size: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }

    &-message {
      margin: 15px 0;
    }

    &-download-wrapper {
      flex-direction: column;
      align-items: center;
      padding: 0 15px;
    }

    &-download {
      min-width: unset;
      max-width: unset;
      width: 100%;
      margin: 6px 0;
    }

    &-callcenter {
      a {
        white-space: nowrap;
        font-size: 14px;
      }

      span {
        font-size: 12px;
      }
    }
  }
}
</style>
